module.exports = __webpack_public_path__ + "img/z-about-img1.e2a1b95c.jpg";